// flow.js资源地址
const flowJSUrlMap: any = {
    rd: 'https://workflow-preonline.dev.weiyun.baidu.com/workflow/api/engine-pre/js-rcv/flow.js?sceneId=knowledge',
    qa: 'https://workflow-preonline.dev.weiyun.baidu.com/workflow/api/engine-pre/js-rcv/flow.js?sceneId=knowledge',
    gray: 'https://developer-gray.baidu-int.com/workflow/api/engine-pre/js-rcv/flow.js?sceneId=knowledge',
    online: 'https://developer.baidu-int.com/workflow/api/engine-pre/js-rcv/flow.js?sceneId=knowledge',
};

const env = process.env.REACT_APP_ENVIRONMENT;

export const flowObj = {
    url: env ? flowJSUrlMap[env] : flowJSUrlMap.online,
    loadStatus: 'success',
    getFlowApi: () => {
        // flow 在 qiankun 微服务框架上需要通过 proxy 访问，此处进行兼容
        return window.flow || window.proxy?.flow;
    },
    setLoadStatus: (status: 'success' | 'fail') => {
        flowObj.loadStatus = status;
    },
    isLoadFail: () => flowObj.loadStatus === 'fail',
    isRecognizeSupported: () => {
        // 非小流量用户没有 linkRecognize 方法，则认为不支持 flow 链接识别
        return !!flowObj.getFlowApi()?.linkRecognize;
    },
};
